import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested, isNotEmpty } from 'class-validator';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';

export class ConfCallDTO {
  @ApiProperty()
  @ApiPropertyOptional()
  Id?: number;
  @ApiProperty()
  @IsNotEmpty({message:"name should not be empty"})
  meetingName:string;
  @ApiProperty()
  @IsNotEmpty({message:"admin token should not be empty"})
  adminToken:string;
  @ApiProperty()
  @IsNotEmpty({message:"user token should not be empty"})
  userToken:string;
  @ApiProperty()
  @ApiPropertyOptional()
  startTime:Date;
  @ApiProperty()
  @ApiPropertyOptional()
  endTime:Date;
  @ApiProperty()
  @IsNotEmpty({message: "meeting id should not be empty"})
  meetingId:string;
  @ApiProperty()
  status: boolean;
  @ApiProperty()
  versionFlag : number;
}

export class PaginationDto {
  @ApiProperty()
  apiVersion?:number;
  @ApiProperty()
  skip:number; 
}


